'use strict';

function sliderStyling() {
    var width = $(window).width();
    if(width < 769){
        $('.styling__items, .staff__items').not('.slick-initialized').slick({
            arrows: false,
            infinite: true,
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 1,
        });
    } else {
        $('.styling__items.slick-initialized, .staff__items.slick-initialized').slick('unslick');
    }
}

function changePositionFollowDevice() {
    const container = document.querySelector('.js-gallery-swiper');
     if (!container) return; 
    const img = container.querySelector('.swiper-slide-active img');
     if (!img) return;
    const icon = container.querySelector('.mainslide .recommend-block__icon');
     if (!icon) return;
    const popupAdd = container.querySelector('.mainslide .group-wl .custom__popup-add');
     if (!icon) return;
  
    const rC = container.getBoundingClientRect();
    const rI = img.getBoundingClientRect();
    var gap = rI.top - rC.top;
          gap = gap < 0 ? 0 : gap;
    const distanceDefaultFrameImage = 16;
    icon.style.top = (gap + distanceDefaultFrameImage) + 'px';
    icon.style.right = '10px';
    icon.classList.remove('d-none');

    const iconImgVisible = container.querySelector('.mainslide .recommend-block__icon img.d-block');
     if (!iconImgVisible) return;
    var iconHeight = $(iconImgVisible)[0].offsetHeight;
    const boxLogin = container.querySelector('.box_extend');
    boxLogin.style.top = (gap + iconHeight + distanceDefaultFrameImage) + 'px';
    popupAdd.style.top = (gap + iconHeight + distanceDefaultFrameImage + 10) + 'px';
    icon.classList.remove('d-none');
}

window.jQuery(document).ready(function () {
    sliderStyling();
});

window.jQuery(window).on('resize', function () {
    sliderStyling();
    changePositionFollowDevice();
});

window.onload = function () {
    changePositionFollowDevice();
};